<script>

import cTable from "@/base/common/index.vue";
import {buildApi} from "@/libs/api.request";
import axios from "axios";
import {getAllService, getWaitSettlementSalesman} from "@/api/user/internal";
import moment from "moment";
import {getBillLinking, getBillLinkingExport} from "@/api/data";

export default {
  name: "index",
  components: {cTable},
  data() {
    let cacheBuff = null;
    return {
      loading: true,
      config: {},
      footer: {},
      modals: {
        display: {
          type: "table",
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1280,
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [
            {
              // outboundTime: 6,
              shipmentNumber: 6,
              // salesman: 6,
              // customerName: 6,
              // serviceCode: 6,
              // serviceName: 6,
            },
          ],
          methods: {
            ok({row, close}) {
              // 过滤条件
              let data = this.handleFilterData(), shipmentNumber = data['shipmentNumber'].trim()
              if (shipmentNumber.length > 0) {
                // 先保存到缓存
                cacheBuff = this.list
                let keywords = shipmentNumber.trim().split("\n")
                this.list = this.list.filter(v => {
                  for (const keyword of keywords) {
                    if (v.shipmentNumber.toUpperCase().indexOf(keyword.toUpperCase()) !== -1) {
                      return true
                    }
                  }
                  return false;
                })

              } else {
                this.list = cacheBuff
              }
            },
          },
          fields: [
            {
              key: "outboundTime",
              name: () => '出库时间',
              placeholder() {
                return '请输入订单号码';
              },
              component: "Input",

            },
            {
              key: "shipmentNumber",
              name: () => '订单号码',
              placeholder() {
                return '请输入订单号码';
              },
              component: "Input",
              bind: {
                type: 'textarea'
              }
            },
            {
              key: "linkedSalesman",
              name: () => '销售名称',
              placeholder() {
                return '请选择启运国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "customerName",
              name: () => '客户名称',
              placeholder() {
                return '请选择启运国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "serviceCode",
              name: () => '服务类型',
              placeholder() {
                return '请选择启运国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "serviceName",
              name: () => '服务项目',
              placeholder() {
                return '请选择启运国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
          ],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => '订单号码',
                key: "shipmentNumber",
                width: 120,
              },
              {
                name: () => '销售名称',
                key: "salesman",
                width: 190,
              }, {
                name: () => '出库时间',
                key: "outboundTime",
                width: 220,
              }, {
                name: () => '客户名',
                key: "shipperAccount",
                width: 140,
              },
              {
                name: () => '服务类别',
                key: "serviceCode",
                width: 140,
              },
              {
                name: () => '服务项目',
                key: "serviceName",
                width: 140,
              },
              {
                name: () => '申报价值',
                key: "values",
                width: 140,
              },
              {
                name: () => '国家',
                key: "targetCountryCode",
                width: 120,
              },
              {
                name: () => '品名',
                key: "categories",
                width: 260,
              },
              {
                name: () => '商品备注',
                key: "remarks",
                width: 260,
              },
              {
                name: () => '件数',
                key: "pcs",
                width: 120,
              },
              {
                name: () => '实际重量',
                key: "weight",
                width: 140,
              },
              {
                name: () => 'T体积重量',
                key: "volumeWeight",
                width: 140,
              },
              {
                name: () => 'T体积方数',
                key: "volume",
                width: 140,
              },
              {
                name: () => 'T计算重',
                key: "chargingWeight",
                width: 140,
              },
              {
                name: () => '单价/RMB/USD/SAR ',
                key: "price",
                width: 180,
              },
              {
                name: () => '运费小计 ',
                key: "transferFees",
                width: 140,
              },
              {
                name: () => '尾程派送费',
                key: "deliverFees",
                width: 140,
              },
              {
                name: () => '理货费',
                key: "tallyingFees",
                width: 140,
              },
              {
                name: () => '报关费',
                key: "customsFees",
                width: 140,
              },
              {
                name: () => '应收小计(RMB)',
                key: "totalAmount",
                width: 180,
              },
            ],
          }
        },
        add: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = this.handleFilterData({
                id: row.id,
              });
              this.$page
                .handleRequestMethods("save", data, true, true).then((res) => {
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 400,
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {},
          },
          grid: [
            {
              bill_code: 24,
              department_id: 24,
              start_time: 24,
              end_time: 24,
            },
          ],
          fields: [
            {
              key: "bill_code",
              name: () => '账单编码',
              placeholder() {
                return '请输入账单编码';
              },
              component: "Input",
              bind: {
                readonly: true
              },
              default: () => {
                return 'BC' + moment().format('YYYYMMDDHH')
              }
            }, {
              name: () => '分公司',
              key: "department_id",
              placeholder() {
                return this.$tz('请选择') + '分公司';
              },
              minWidth: 60,
              component: "Select",
              options: [],
              methods: {
                async list({field}) {
                  field.options = (await getWaitSettlementSalesman()).data.payload;
                  this.$forceUpdate();
                }
              }
            }, {
              name: () => '开始时间',
              key: "start_time",
              placeholder() {
                return this.$tz('请选择') + '出库开始时间';
              },
              minWidth: 60,
              component: "DatePicker",
              bind: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
              }
            }, {
              name: () => '结束时间',
              key: "end_time",
              placeholder() {
                return this.$tz('请选择') + '出库结束时间';
              },
              minWidth: 60,
              component: "DatePicker",
              bind: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
              },
              methods: {
                "on-change"({ formData }) {
                  let time = this.$page.format.timeFormat(formData.end_time);
                  if (time.slice(-8) === "00:00:00") {
                    time = time.split(" ")[0] + " " + "23:59:59";
                    formData.end_time = time;
                  }
                }
              }
            }
          ],

        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            disabledDate: true,
            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            disabledDate: true,
            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "staffId",
            placeholder() {
              return this.$tz("请选择,销售名称");
            },
            component: "Select",
            options: [],
            methods: {
              async list({field}) {
                let res = (await getAllService()).data.payload;
                let arr = [5];
                let data = [];
                arr.forEach(item => {
                  data = data.concat(res[item]);
                });
                field.options = data;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("请选择,订单状态");
            },
            component: "Select",
            options: [
              {label: '全部', value: ''},
              {label: '已创建', value: 'Created'},
              {label: '销售已确认', value: 'SaleConfirm'},
              {label: '财务已确认', value: 'BillConfirm'},
              {label: '客户已支付', value: 'Paid'},
            ],
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      methods: {
        ...buildApi({
          get: ['/finance/b2b/bill/index&list',],
          post: ['/finance/b2b/bill/save', name + '/finance/b2b/bill/delete/:id&del']
        })
      },
      fields: [
        {
          name: () => '账单编码',
          key: "bill_code",
          width: 200,
          render: function (h, {row, index}) {
            // 读取后端的信息
            return h('Button', {
              props: {type: 'primary', size: 'small'}, on: {
                click: () => {
                  this.getModal("display").open(null, function () {
                    getBillLinking(row.id).then(r => {
                      this.list = r.data.payload
                      this.setTitle('账单信息');
                    })
                  });
                }
              }
            }, row.bill_code)
          }
        }, {
          name: () => '账单名称',
          key: "prefix",
          width: 500,
        }, {
          name: () => this.$tz("分公司名称"),
          key: "department_name",
          width: 320,
        }, {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          width: 210,
        }, {
          name: () => '筛选时间',
          key: "range",
          width: 380,
        }, {
          name: () => this.$tz("当前状态"),
          key: "status",
          width: 110,
          render: (h, {row, index}) => {
            return h('Tag', {props: {color: row.status.tag, type: 'border'}}, row.status.text)
          }
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          fixed: "right",
          width: 160,
          list: [
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
            {
              name: () => '导出Excel',
              type: "export",
              fnName: "export",
              bind: {
                type: "success",
              },
            },
          ],
          methods: {
            export({row}) {
              this.openLoading();
              getBillLinkingExport(row.id).then(r => {
                this.closeLoading()
                window.open(r.data.payload.uri)
              })
            },
            delete({row}) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {id: row.id},
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ]
    }
  },
}

</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<style scoped>

</style>
